<lib-ribera-loader-ui [loader]="spinner.loading()" ></lib-ribera-loader-ui>
<div class="layout-wrapper shell" [class.logged-in]="isLoggedIn" [class.collapsed]="isCollapsed()">
 
  @if (isLoggedIn) {
    <lib-sidebar-client 
      class="sidebar"
      [class.custom-display]="isLoggedIn"
      (toggleSidebar)="toggleSidebar($event)"
    />
  }
  
  <lib-header
    class="header"
    [isCollapsed]="isCollapsed()"
  />

  <main class="content-main" [class.custom-width]="isLoggedIn">
    @if (isLoggedIn) {
      @if (isDashboardRoute()) {
        <lib-promoters-profile-ui class="only-mobile"></lib-promoters-profile-ui>
      }
      <lib-dashboard-tabs></lib-dashboard-tabs>
    }
    <router-outlet></router-outlet>
  </main>
  
  @if (!isMemberEventsRoute()) {
    <lib-footer
      [class.custom-width]="isLoggedIn"
    />
  }
</div>
